"use client"

// Single source of truth lives in lib/hooks/use-toast (sonner compat engine).
export { useToast, toast } from "@/lib/hooks/use-toast"
export type { ToastInput, ToastVariant } from "@/lib/hooks/use-toast"
